import { api } from './api';

// GET all drivers (table/minimal info)
export const getDrivers = (params?: any) => api.get('/admin/drivers', { params });

// GET full driver details
export const getDriverDetails = (id: number) => api.get(`/admin/driver/${id}`);

// UPDATE driver (editable fields - including suspend/activate)
export const updateDriver = (id: number, data: any) => api.patch(`/admin/driver/${id}`, data);

// APPROVE driver
export const approveDriver = (id: number, data: any) => api.patch(`/admin/driver/approve/${id}`, data);

// SUSPEND a driver (generic PATCH)
export const suspendDriver = (id: number) =>
    api.patch(`/admin/driver/${id}`, { isAvailable: false, isDeleted: false }); // Or also update User.suspended if needed

// ACTIVATE a driver (generic PATCH)
export const activateDriver = (id: number) =>
    api.patch(`/admin/driver/${id}`, { isAvailable: true, isDeleted: false });

// DELETE a driver
export const deleteDriver = (id: number) => api.delete(`/admin/driver/${id}`);

/**
 * Release a driver from the agent who claimed them, so they can be enrolled again.
 * `resetApproval` clears the approval stamp AND the RC/DL/photo verification it produced (back to
 * PENDING), returning the driver to the "Ready to approve" worklist — that un-approves a live
 * driver, so it is always an explicit choice. Web-dashboard only: the ManagerApp authenticates
 * with a Firebase token against /api/staff and cannot reach /api/admin at all.
 */
export const unclaimDriver = (id: number, resetApproval = false) =>
    api.post(`/admin/driver/${id}/unclaim`, { resetApproval });

// Get a signed (secure, temporary) URL to download an image
export const getSignedDriverDocUrl = async (s3Key?: string | null): Promise<string> => {
    if (!s3Key) return "";
    try {
        const res = await api.get(`/admin/driver-doc-url/${encodeURIComponent(s3Key)}`);
        return typeof res.data.signedUrl === "string" ? res.data.signedUrl : "";
    } catch (err) {
        return "";
    }
};

export const uploadDriverDocument = (data: FormData) =>
    api.post('/admin/driver/document', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });